import { render, staticRenderFns } from "./KiosksTable.vue?vue&type=template&id=313be358"
import script from "./KiosksTable.vue?vue&type=script&lang=js"
export * from "./KiosksTable.vue?vue&type=script&lang=js"
import style0 from "./KiosksTable.vue?vue&type=style&index=0&id=313be358&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports